/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Permissions_TitleInputs */

const en_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide Permissions`)
};

const fr_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations du guide`)
};

const de_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfadenberechtigungen`)
};

const it_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorizzazioni della guida`)
};

const ru_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководство по правам доступа`)
};

const es_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos de guía`)
};

const zh_cn2_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向导权限`)
};

const ja_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイドの権限`)
};

const hi_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गाइड अनुमतियाँ`)
};

const pt_pt2_knp_manager_permissions_title = /** @type {(inputs: Knp_Manager_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões do guia`)
};

/**
* | output |
* | --- |
* | "Guide Permissions" |
*
* @param {Knp_Manager_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_title = /** @type {((inputs?: Knp_Manager_Permissions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_permissions_title(inputs)
	if (locale === "de") return de_knp_manager_permissions_title(inputs)
	if (locale === "it") return it_knp_manager_permissions_title(inputs)
	if (locale === "ru") return ru_knp_manager_permissions_title(inputs)
	if (locale === "es") return es_knp_manager_permissions_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_permissions_title(inputs)
	if (locale === "ja") return ja_knp_manager_permissions_title(inputs)
	if (locale === "hi") return hi_knp_manager_permissions_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_permissions_title(inputs)
	return en_knp_manager_permissions_title(inputs)
});